// countries.jsx — complete country reference data (auto-generated from world-countries).
// Each entry: { code (ISO 3166-1 alpha-2), name, dial (calling code), demonym, flag (emoji) }.
// Used by CountrySelect for the Nationality / Country of Residence / Phone-code dropdowns.
export const COUNTRIES = [
  { code: "AF", name: "Afghanistan", dial: "+93", demonym: "Afghan", flag: "🇦🇫" },
  { code: "AX", name: "Åland Islands", dial: "+35818", demonym: "Ålandish", flag: "🇦🇽" },
  { code: "AL", name: "Albania", dial: "+355", demonym: "Albanian", flag: "🇦🇱" },
  { code: "DZ", name: "Algeria", dial: "+213", demonym: "Algerian", flag: "🇩🇿" },
  { code: "AS", name: "American Samoa", dial: "+1684", demonym: "American Samoan", flag: "🇦🇸" },
  { code: "AD", name: "Andorra", dial: "+376", demonym: "Andorran", flag: "🇦🇩" },
  { code: "AO", name: "Angola", dial: "+244", demonym: "Angolan", flag: "🇦🇴" },
  { code: "AI", name: "Anguilla", dial: "+1264", demonym: "Anguillian", flag: "🇦🇮" },
  { code: "AG", name: "Antigua and Barbuda", dial: "+1268", demonym: "Antiguan, Barbudan", flag: "🇦🇬" },
  { code: "AR", name: "Argentina", dial: "+54", demonym: "Argentine", flag: "🇦🇷" },
  { code: "AM", name: "Armenia", dial: "+374", demonym: "Armenian", flag: "🇦🇲" },
  { code: "AW", name: "Aruba", dial: "+297", demonym: "Aruban", flag: "🇦🇼" },
  { code: "AU", name: "Australia", dial: "+61", demonym: "Australian", flag: "🇦🇺" },
  { code: "AT", name: "Austria", dial: "+43", demonym: "Austrian", flag: "🇦🇹" },
  { code: "AZ", name: "Azerbaijan", dial: "+994", demonym: "Azerbaijani", flag: "🇦🇿" },
  { code: "BS", name: "Bahamas", dial: "+1242", demonym: "Bahamian", flag: "🇧🇸" },
  { code: "BH", name: "Bahrain", dial: "+973", demonym: "Bahraini", flag: "🇧🇭" },
  { code: "BD", name: "Bangladesh", dial: "+880", demonym: "Bangladeshi", flag: "🇧🇩" },
  { code: "BB", name: "Barbados", dial: "+1246", demonym: "Barbadian", flag: "🇧🇧" },
  { code: "BY", name: "Belarus", dial: "+375", demonym: "Belarusian", flag: "🇧🇾" },
  { code: "BE", name: "Belgium", dial: "+32", demonym: "Belgian", flag: "🇧🇪" },
  { code: "BZ", name: "Belize", dial: "+501", demonym: "Belizean", flag: "🇧🇿" },
  { code: "BJ", name: "Benin", dial: "+229", demonym: "Beninese", flag: "🇧🇯" },
  { code: "BM", name: "Bermuda", dial: "+1441", demonym: "Bermudian", flag: "🇧🇲" },
  { code: "BT", name: "Bhutan", dial: "+975", demonym: "Bhutanese", flag: "🇧🇹" },
  { code: "BO", name: "Bolivia", dial: "+591", demonym: "Bolivian", flag: "🇧🇴" },
  { code: "BA", name: "Bosnia and Herzegovina", dial: "+387", demonym: "Bosnian, Herzegovinian", flag: "🇧🇦" },
  { code: "BW", name: "Botswana", dial: "+267", demonym: "Motswana", flag: "🇧🇼" },
  { code: "BV", name: "Bouvet Island", dial: "+47", demonym: "Bouvet Island", flag: "🇧🇻" },
  { code: "BR", name: "Brazil", dial: "+55", demonym: "Brazilian", flag: "🇧🇷" },
  { code: "IO", name: "British Indian Ocean Territory", dial: "+246", demonym: "Indian", flag: "🇮🇴" },
  { code: "VG", name: "British Virgin Islands", dial: "+1284", demonym: "Virgin Islander", flag: "🇻🇬" },
  { code: "BN", name: "Brunei", dial: "+673", demonym: "Bruneian", flag: "🇧🇳" },
  { code: "BG", name: "Bulgaria", dial: "+359", demonym: "Bulgarian", flag: "🇧🇬" },
  { code: "BF", name: "Burkina Faso", dial: "+226", demonym: "Burkinabe", flag: "🇧🇫" },
  { code: "BI", name: "Burundi", dial: "+257", demonym: "Burundian", flag: "🇧🇮" },
  { code: "KH", name: "Cambodia", dial: "+855", demonym: "Cambodian", flag: "🇰🇭" },
  { code: "CM", name: "Cameroon", dial: "+237", demonym: "Cameroonian", flag: "🇨🇲" },
  { code: "CA", name: "Canada", dial: "+1", demonym: "Canadian", flag: "🇨🇦" },
  { code: "CV", name: "Cape Verde", dial: "+238", demonym: "Cape Verdian", flag: "🇨🇻" },
  { code: "BQ", name: "Caribbean Netherlands", dial: "+599", demonym: "Dutch", flag: "" },
  { code: "KY", name: "Cayman Islands", dial: "+1345", demonym: "Caymanian", flag: "🇰🇾" },
  { code: "CF", name: "Central African Republic", dial: "+236", demonym: "Central African", flag: "🇨🇫" },
  { code: "TD", name: "Chad", dial: "+235", demonym: "Chadian", flag: "🇹🇩" },
  { code: "CL", name: "Chile", dial: "+56", demonym: "Chilean", flag: "🇨🇱" },
  { code: "CN", name: "China", dial: "+86", demonym: "Chinese", flag: "🇨🇳" },
  { code: "CX", name: "Christmas Island", dial: "+61", demonym: "Christmas Islander", flag: "🇨🇽" },
  { code: "CC", name: "Cocos (Keeling) Islands", dial: "+61", demonym: "Cocos Islander", flag: "🇨🇨" },
  { code: "CO", name: "Colombia", dial: "+57", demonym: "Colombian", flag: "🇨🇴" },
  { code: "KM", name: "Comoros", dial: "+269", demonym: "Comoran", flag: "🇰🇲" },
  { code: "CK", name: "Cook Islands", dial: "+682", demonym: "Cook Islander", flag: "🇨🇰" },
  { code: "CR", name: "Costa Rica", dial: "+506", demonym: "Costa Rican", flag: "🇨🇷" },
  { code: "HR", name: "Croatia", dial: "+385", demonym: "Croatian", flag: "🇭🇷" },
  { code: "CU", name: "Cuba", dial: "+53", demonym: "Cuban", flag: "🇨🇺" },
  { code: "CW", name: "Curaçao", dial: "+599", demonym: "Curaçaoan", flag: "🇨🇼" },
  { code: "CY", name: "Cyprus", dial: "+357", demonym: "Cypriot", flag: "🇨🇾" },
  { code: "CZ", name: "Czechia", dial: "+420", demonym: "Czech", flag: "🇨🇿" },
  { code: "DK", name: "Denmark", dial: "+45", demonym: "Danish", flag: "🇩🇰" },
  { code: "DJ", name: "Djibouti", dial: "+253", demonym: "Djibouti", flag: "🇩🇯" },
  { code: "DM", name: "Dominica", dial: "+1767", demonym: "Dominican", flag: "🇩🇲" },
  { code: "DO", name: "Dominican Republic", dial: "+1", demonym: "Dominican", flag: "🇩🇴" },
  { code: "CD", name: "DR Congo", dial: "+243", demonym: "Congolese", flag: "🇨🇩" },
  { code: "EC", name: "Ecuador", dial: "+593", demonym: "Ecuadorean", flag: "🇪🇨" },
  { code: "EG", name: "Egypt", dial: "+20", demonym: "Egyptian", flag: "🇪🇬" },
  { code: "SV", name: "El Salvador", dial: "+503", demonym: "Salvadoran", flag: "🇸🇻" },
  { code: "GQ", name: "Equatorial Guinea", dial: "+240", demonym: "Equatorial Guinean", flag: "🇬🇶" },
  { code: "ER", name: "Eritrea", dial: "+291", demonym: "Eritrean", flag: "🇪🇷" },
  { code: "EE", name: "Estonia", dial: "+372", demonym: "Estonian", flag: "🇪🇪" },
  { code: "SZ", name: "Eswatini", dial: "+268", demonym: "Swazi", flag: "🇸🇿" },
  { code: "ET", name: "Ethiopia", dial: "+251", demonym: "Ethiopian", flag: "🇪🇹" },
  { code: "FK", name: "Falkland Islands", dial: "+500", demonym: "Falkland Islander", flag: "🇫🇰" },
  { code: "FO", name: "Faroe Islands", dial: "+298", demonym: "Faroese", flag: "🇫🇴" },
  { code: "FJ", name: "Fiji", dial: "+679", demonym: "Fijian", flag: "🇫🇯" },
  { code: "FI", name: "Finland", dial: "+358", demonym: "Finnish", flag: "🇫🇮" },
  { code: "FR", name: "France", dial: "+33", demonym: "French", flag: "🇫🇷" },
  { code: "GF", name: "French Guiana", dial: "+594", demonym: "Guianan", flag: "🇬🇫" },
  { code: "PF", name: "French Polynesia", dial: "+689", demonym: "French Polynesian", flag: "🇵🇫" },
  { code: "TF", name: "French Southern and Antarctic Lands", dial: "+262", demonym: "French", flag: "🇹🇫" },
  { code: "GA", name: "Gabon", dial: "+241", demonym: "Gabonese", flag: "🇬🇦" },
  { code: "GM", name: "Gambia", dial: "+220", demonym: "Gambian", flag: "🇬🇲" },
  { code: "GE", name: "Georgia", dial: "+995", demonym: "Georgian", flag: "🇬🇪" },
  { code: "DE", name: "Germany", dial: "+49", demonym: "German", flag: "🇩🇪" },
  { code: "GH", name: "Ghana", dial: "+233", demonym: "Ghanaian", flag: "🇬🇭" },
  { code: "GI", name: "Gibraltar", dial: "+350", demonym: "Gibraltar", flag: "🇬🇮" },
  { code: "GR", name: "Greece", dial: "+30", demonym: "Greek", flag: "🇬🇷" },
  { code: "GL", name: "Greenland", dial: "+299", demonym: "Greenlandic", flag: "🇬🇱" },
  { code: "GD", name: "Grenada", dial: "+1473", demonym: "Grenadian", flag: "🇬🇩" },
  { code: "GP", name: "Guadeloupe", dial: "+590", demonym: "Guadeloupian", flag: "🇬🇵" },
  { code: "GU", name: "Guam", dial: "+1671", demonym: "Guamanian", flag: "🇬🇺" },
  { code: "GT", name: "Guatemala", dial: "+502", demonym: "Guatemalan", flag: "🇬🇹" },
  { code: "GG", name: "Guernsey", dial: "+44", demonym: "Channel Islander", flag: "🇬🇬" },
  { code: "GN", name: "Guinea", dial: "+224", demonym: "Guinean", flag: "🇬🇳" },
  { code: "GW", name: "Guinea-Bissau", dial: "+245", demonym: "Guinea-Bissauan", flag: "🇬🇼" },
  { code: "GY", name: "Guyana", dial: "+592", demonym: "Guyanese", flag: "🇬🇾" },
  { code: "HT", name: "Haiti", dial: "+509", demonym: "Haitian", flag: "🇭🇹" },
  { code: "HN", name: "Honduras", dial: "+504", demonym: "Honduran", flag: "🇭🇳" },
  { code: "HK", name: "Hong Kong", dial: "+852", demonym: "Hong Konger", flag: "🇭🇰" },
  { code: "HU", name: "Hungary", dial: "+36", demonym: "Hungarian", flag: "🇭🇺" },
  { code: "IS", name: "Iceland", dial: "+354", demonym: "Icelander", flag: "🇮🇸" },
  { code: "IN", name: "India", dial: "+91", demonym: "Indian", flag: "🇮🇳" },
  { code: "ID", name: "Indonesia", dial: "+62", demonym: "Indonesian", flag: "🇮🇩" },
  { code: "IR", name: "Iran", dial: "+98", demonym: "Iranian", flag: "🇮🇷" },
  { code: "IQ", name: "Iraq", dial: "+964", demonym: "Iraqi", flag: "🇮🇶" },
  { code: "IE", name: "Ireland", dial: "+353", demonym: "Irish", flag: "🇮🇪" },
  { code: "IM", name: "Isle of Man", dial: "+44", demonym: "Manx", flag: "🇮🇲" },
  { code: "IL", name: "Israel", dial: "+972", demonym: "Israeli", flag: "🇮🇱" },
  { code: "IT", name: "Italy", dial: "+39", demonym: "Italian", flag: "🇮🇹" },
  { code: "CI", name: "Ivory Coast", dial: "+225", demonym: "Ivorian", flag: "🇨🇮" },
  { code: "JM", name: "Jamaica", dial: "+1876", demonym: "Jamaican", flag: "🇯🇲" },
  { code: "JP", name: "Japan", dial: "+81", demonym: "Japanese", flag: "🇯🇵" },
  { code: "JE", name: "Jersey", dial: "+44", demonym: "Channel Islander", flag: "🇯🇪" },
  { code: "JO", name: "Jordan", dial: "+962", demonym: "Jordanian", flag: "🇯🇴" },
  { code: "KZ", name: "Kazakhstan", dial: "+7", demonym: "Kazakhstani", flag: "🇰🇿" },
  { code: "KE", name: "Kenya", dial: "+254", demonym: "Kenyan", flag: "🇰🇪" },
  { code: "KI", name: "Kiribati", dial: "+686", demonym: "I-Kiribati", flag: "🇰🇮" },
  { code: "XK", name: "Kosovo", dial: "+383", demonym: "Kosovar", flag: "🇽🇰" },
  { code: "KW", name: "Kuwait", dial: "+965", demonym: "Kuwaiti", flag: "🇰🇼" },
  { code: "KG", name: "Kyrgyzstan", dial: "+996", demonym: "Kirghiz", flag: "🇰🇬" },
  { code: "LA", name: "Laos", dial: "+856", demonym: "Laotian", flag: "🇱🇦" },
  { code: "LV", name: "Latvia", dial: "+371", demonym: "Latvian", flag: "🇱🇻" },
  { code: "LB", name: "Lebanon", dial: "+961", demonym: "Lebanese", flag: "🇱🇧" },
  { code: "LS", name: "Lesotho", dial: "+266", demonym: "Mosotho", flag: "🇱🇸" },
  { code: "LR", name: "Liberia", dial: "+231", demonym: "Liberian", flag: "🇱🇷" },
  { code: "LY", name: "Libya", dial: "+218", demonym: "Libyan", flag: "🇱🇾" },
  { code: "LI", name: "Liechtenstein", dial: "+423", demonym: "Liechtensteiner", flag: "🇱🇮" },
  { code: "LT", name: "Lithuania", dial: "+370", demonym: "Lithuanian", flag: "🇱🇹" },
  { code: "LU", name: "Luxembourg", dial: "+352", demonym: "Luxembourger", flag: "🇱🇺" },
  { code: "MO", name: "Macau", dial: "+853", demonym: "Macanese", flag: "🇲🇴" },
  { code: "MG", name: "Madagascar", dial: "+261", demonym: "Malagasy", flag: "🇲🇬" },
  { code: "MW", name: "Malawi", dial: "+265", demonym: "Malawian", flag: "🇲🇼" },
  { code: "MY", name: "Malaysia", dial: "+60", demonym: "Malaysian", flag: "🇲🇾" },
  { code: "MV", name: "Maldives", dial: "+960", demonym: "Maldivan", flag: "🇲🇻" },
  { code: "ML", name: "Mali", dial: "+223", demonym: "Malian", flag: "🇲🇱" },
  { code: "MT", name: "Malta", dial: "+356", demonym: "Maltese", flag: "🇲🇹" },
  { code: "MH", name: "Marshall Islands", dial: "+692", demonym: "Marshallese", flag: "🇲🇭" },
  { code: "MQ", name: "Martinique", dial: "+596", demonym: "Martinican", flag: "🇲🇶" },
  { code: "MR", name: "Mauritania", dial: "+222", demonym: "Mauritanian", flag: "🇲🇷" },
  { code: "MU", name: "Mauritius", dial: "+230", demonym: "Mauritian", flag: "🇲🇺" },
  { code: "YT", name: "Mayotte", dial: "+262", demonym: "Mahoran", flag: "🇾🇹" },
  { code: "MX", name: "Mexico", dial: "+52", demonym: "Mexican", flag: "🇲🇽" },
  { code: "FM", name: "Micronesia", dial: "+691", demonym: "Micronesian", flag: "🇫🇲" },
  { code: "MD", name: "Moldova", dial: "+373", demonym: "Moldovan", flag: "🇲🇩" },
  { code: "MC", name: "Monaco", dial: "+377", demonym: "Monegasque", flag: "🇲🇨" },
  { code: "MN", name: "Mongolia", dial: "+976", demonym: "Mongolian", flag: "🇲🇳" },
  { code: "ME", name: "Montenegro", dial: "+382", demonym: "Montenegrin", flag: "🇲🇪" },
  { code: "MS", name: "Montserrat", dial: "+1664", demonym: "Montserratian", flag: "🇲🇸" },
  { code: "MA", name: "Morocco", dial: "+212", demonym: "Moroccan", flag: "🇲🇦" },
  { code: "MZ", name: "Mozambique", dial: "+258", demonym: "Mozambican", flag: "🇲🇿" },
  { code: "MM", name: "Myanmar", dial: "+95", demonym: "Burmese", flag: "🇲🇲" },
  { code: "NA", name: "Namibia", dial: "+264", demonym: "Namibian", flag: "🇳🇦" },
  { code: "NR", name: "Nauru", dial: "+674", demonym: "Nauruan", flag: "🇳🇷" },
  { code: "NP", name: "Nepal", dial: "+977", demonym: "Nepalese", flag: "🇳🇵" },
  { code: "NL", name: "Netherlands", dial: "+31", demonym: "Dutch", flag: "🇳🇱" },
  { code: "NC", name: "New Caledonia", dial: "+687", demonym: "New Caledonian", flag: "🇳🇨" },
  { code: "NZ", name: "New Zealand", dial: "+64", demonym: "New Zealander", flag: "🇳🇿" },
  { code: "NI", name: "Nicaragua", dial: "+505", demonym: "Nicaraguan", flag: "🇳🇮" },
  { code: "NE", name: "Niger", dial: "+227", demonym: "Nigerien", flag: "🇳🇪" },
  { code: "NG", name: "Nigeria", dial: "+234", demonym: "Nigerian", flag: "🇳🇬" },
  { code: "NU", name: "Niue", dial: "+683", demonym: "Niuean", flag: "🇳🇺" },
  { code: "NF", name: "Norfolk Island", dial: "+672", demonym: "Norfolk Islander", flag: "🇳🇫" },
  { code: "KP", name: "North Korea", dial: "+850", demonym: "North Korean", flag: "🇰🇵" },
  { code: "MK", name: "North Macedonia", dial: "+389", demonym: "Macedonian", flag: "🇲🇰" },
  { code: "MP", name: "Northern Mariana Islands", dial: "+1670", demonym: "American", flag: "🇲🇵" },
  { code: "NO", name: "Norway", dial: "+47", demonym: "Norwegian", flag: "🇳🇴" },
  { code: "OM", name: "Oman", dial: "+968", demonym: "Omani", flag: "🇴🇲" },
  { code: "PK", name: "Pakistan", dial: "+92", demonym: "Pakistani", flag: "🇵🇰" },
  { code: "PW", name: "Palau", dial: "+680", demonym: "Palauan", flag: "🇵🇼" },
  { code: "PS", name: "Palestine", dial: "+970", demonym: "Palestinian", flag: "🇵🇸" },
  { code: "PA", name: "Panama", dial: "+507", demonym: "Panamanian", flag: "🇵🇦" },
  { code: "PG", name: "Papua New Guinea", dial: "+675", demonym: "Papua New Guinean", flag: "🇵🇬" },
  { code: "PY", name: "Paraguay", dial: "+595", demonym: "Paraguayan", flag: "🇵🇾" },
  { code: "PE", name: "Peru", dial: "+51", demonym: "Peruvian", flag: "🇵🇪" },
  { code: "PH", name: "Philippines", dial: "+63", demonym: "Filipino", flag: "🇵🇭" },
  { code: "PN", name: "Pitcairn Islands", dial: "+64", demonym: "Pitcairn Islander", flag: "🇵🇳" },
  { code: "PL", name: "Poland", dial: "+48", demonym: "Polish", flag: "🇵🇱" },
  { code: "PT", name: "Portugal", dial: "+351", demonym: "Portuguese", flag: "🇵🇹" },
  { code: "PR", name: "Puerto Rico", dial: "+1", demonym: "Puerto Rican", flag: "🇵🇷" },
  { code: "QA", name: "Qatar", dial: "+974", demonym: "Qatari", flag: "🇶🇦" },
  { code: "CG", name: "Republic of the Congo", dial: "+242", demonym: "Congolese", flag: "🇨🇬" },
  { code: "RE", name: "Réunion", dial: "+262", demonym: "Réunionese", flag: "🇷🇪" },
  { code: "RO", name: "Romania", dial: "+40", demonym: "Romanian", flag: "🇷🇴" },
  { code: "RU", name: "Russia", dial: "+7", demonym: "Russian", flag: "🇷🇺" },
  { code: "RW", name: "Rwanda", dial: "+250", demonym: "Rwandan", flag: "🇷🇼" },
  { code: "BL", name: "Saint Barthélemy", dial: "+590", demonym: "Saint Barthélemy Islander", flag: "🇧🇱" },
  { code: "SH", name: "Saint Helena, Ascension and Tristan da Cunha", dial: "+2", demonym: "Saint Helenian", flag: "🇸🇭" },
  { code: "KN", name: "Saint Kitts and Nevis", dial: "+1869", demonym: "Kittitian or Nevisian", flag: "🇰🇳" },
  { code: "LC", name: "Saint Lucia", dial: "+1758", demonym: "Saint Lucian", flag: "🇱🇨" },
  { code: "MF", name: "Saint Martin", dial: "+590", demonym: "Saint Martin Islander", flag: "🇲🇫" },
  { code: "PM", name: "Saint Pierre and Miquelon", dial: "+508", demonym: "Saint-Pierrais, Miquelonnais", flag: "🇵🇲" },
  { code: "VC", name: "Saint Vincent and the Grenadines", dial: "+1784", demonym: "Saint Vincentian", flag: "🇻🇨" },
  { code: "WS", name: "Samoa", dial: "+685", demonym: "Samoan", flag: "🇼🇸" },
  { code: "SM", name: "San Marino", dial: "+378", demonym: "Sammarinese", flag: "🇸🇲" },
  { code: "ST", name: "São Tomé and Príncipe", dial: "+239", demonym: "Sao Tomean", flag: "🇸🇹" },
  { code: "SA", name: "Saudi Arabia", dial: "+966", demonym: "Saudi Arabian", flag: "🇸🇦" },
  { code: "SN", name: "Senegal", dial: "+221", demonym: "Senegalese", flag: "🇸🇳" },
  { code: "RS", name: "Serbia", dial: "+381", demonym: "Serbian", flag: "🇷🇸" },
  { code: "SC", name: "Seychelles", dial: "+248", demonym: "Seychellois", flag: "🇸🇨" },
  { code: "SL", name: "Sierra Leone", dial: "+232", demonym: "Sierra Leonean", flag: "🇸🇱" },
  { code: "SG", name: "Singapore", dial: "+65", demonym: "Singaporean", flag: "🇸🇬" },
  { code: "SX", name: "Sint Maarten", dial: "+1721", demonym: "St. Maartener", flag: "🇸🇽" },
  { code: "SK", name: "Slovakia", dial: "+421", demonym: "Slovak", flag: "🇸🇰" },
  { code: "SI", name: "Slovenia", dial: "+386", demonym: "Slovene", flag: "🇸🇮" },
  { code: "SB", name: "Solomon Islands", dial: "+677", demonym: "Solomon Islander", flag: "🇸🇧" },
  { code: "SO", name: "Somalia", dial: "+252", demonym: "Somali", flag: "🇸🇴" },
  { code: "ZA", name: "South Africa", dial: "+27", demonym: "South African", flag: "🇿🇦" },
  { code: "GS", name: "South Georgia", dial: "+500", demonym: "South Georgian South Sandwich Islander", flag: "🇬🇸" },
  { code: "KR", name: "South Korea", dial: "+82", demonym: "South Korean", flag: "🇰🇷" },
  { code: "SS", name: "South Sudan", dial: "+211", demonym: "South Sudanese", flag: "🇸🇸" },
  { code: "ES", name: "Spain", dial: "+34", demonym: "Spanish", flag: "🇪🇸" },
  { code: "LK", name: "Sri Lanka", dial: "+94", demonym: "Sri Lankan", flag: "🇱🇰" },
  { code: "SD", name: "Sudan", dial: "+249", demonym: "Sudanese", flag: "🇸🇩" },
  { code: "SR", name: "Suriname", dial: "+597", demonym: "Surinamer", flag: "🇸🇷" },
  { code: "SJ", name: "Svalbard and Jan Mayen", dial: "+4779", demonym: "Norwegian", flag: "🇸🇯" },
  { code: "SE", name: "Sweden", dial: "+46", demonym: "Swedish", flag: "🇸🇪" },
  { code: "CH", name: "Switzerland", dial: "+41", demonym: "Swiss", flag: "🇨🇭" },
  { code: "SY", name: "Syria", dial: "+963", demonym: "Syrian", flag: "🇸🇾" },
  { code: "TW", name: "Taiwan", dial: "+886", demonym: "Taiwanese", flag: "🇹🇼" },
  { code: "TJ", name: "Tajikistan", dial: "+992", demonym: "Tadzhik", flag: "🇹🇯" },
  { code: "TZ", name: "Tanzania", dial: "+255", demonym: "Tanzanian", flag: "🇹🇿" },
  { code: "TH", name: "Thailand", dial: "+66", demonym: "Thai", flag: "🇹🇭" },
  { code: "TL", name: "Timor-Leste", dial: "+670", demonym: "East Timorese", flag: "🇹🇱" },
  { code: "TG", name: "Togo", dial: "+228", demonym: "Togolese", flag: "🇹🇬" },
  { code: "TK", name: "Tokelau", dial: "+690", demonym: "Tokelauan", flag: "🇹🇰" },
  { code: "TO", name: "Tonga", dial: "+676", demonym: "Tongan", flag: "🇹🇴" },
  { code: "TT", name: "Trinidad and Tobago", dial: "+1868", demonym: "Trinidadian", flag: "🇹🇹" },
  { code: "TN", name: "Tunisia", dial: "+216", demonym: "Tunisian", flag: "🇹🇳" },
  { code: "TR", name: "Türkiye", dial: "+90", demonym: "Turkish", flag: "🇹🇷" },
  { code: "TM", name: "Turkmenistan", dial: "+993", demonym: "Turkmen", flag: "🇹🇲" },
  { code: "TC", name: "Turks and Caicos Islands", dial: "+1649", demonym: "Turks and Caicos Islander", flag: "🇹🇨" },
  { code: "TV", name: "Tuvalu", dial: "+688", demonym: "Tuvaluan", flag: "🇹🇻" },
  { code: "UG", name: "Uganda", dial: "+256", demonym: "Ugandan", flag: "🇺🇬" },
  { code: "UA", name: "Ukraine", dial: "+380", demonym: "Ukrainian", flag: "🇺🇦" },
  { code: "AE", name: "United Arab Emirates", dial: "+971", demonym: "Emirati", flag: "🇦🇪" },
  { code: "GB", name: "United Kingdom", dial: "+44", demonym: "British", flag: "🇬🇧" },
  { code: "US", name: "United States", dial: "+1", demonym: "American", flag: "🇺🇸" },
  { code: "UM", name: "United States Minor Outlying Islands", dial: "+268", demonym: "American Islander", flag: "🇺🇲" },
  { code: "VI", name: "United States Virgin Islands", dial: "+1340", demonym: "Virgin Islander", flag: "🇻🇮" },
  { code: "UY", name: "Uruguay", dial: "+598", demonym: "Uruguayan", flag: "🇺🇾" },
  { code: "UZ", name: "Uzbekistan", dial: "+998", demonym: "Uzbekistani", flag: "🇺🇿" },
  { code: "VU", name: "Vanuatu", dial: "+678", demonym: "Ni-Vanuatu", flag: "🇻🇺" },
  { code: "VA", name: "Vatican City", dial: "+3", demonym: "Vatican", flag: "🇻🇦" },
  { code: "VE", name: "Venezuela", dial: "+58", demonym: "Venezuelan", flag: "🇻🇪" },
  { code: "VN", name: "Vietnam", dial: "+84", demonym: "Vietnamese", flag: "🇻🇳" },
  { code: "WF", name: "Wallis and Futuna", dial: "+681", demonym: "Wallis and Futuna Islander", flag: "🇼🇫" },
  { code: "EH", name: "Western Sahara", dial: "+2", demonym: "Sahrawi", flag: "🇪🇭" },
  { code: "YE", name: "Yemen", dial: "+967", demonym: "Yemeni", flag: "🇾🇪" },
  { code: "ZM", name: "Zambia", dial: "+260", demonym: "Zambian", flag: "🇿🇲" },
  { code: "ZW", name: "Zimbabwe", dial: "+263", demonym: "Zimbabwean", flag: "🇿🇼" },
];

// ── Lookup helpers ───────────────────────────────────────────────────────────
// Match a stored free-text value back to a country, tolerant of how older
// records were saved (country name, demonym, ISO code, or a dial code / phone
// string that starts with a dial code). Returns the country object or null.
export function findCountry(value) {
  if (!value) return null;
  const v = String(value).trim();
  if (!v) return null;
  const lc = v.toLowerCase();
  // exact name / demonym / iso code
  let hit = COUNTRIES.find(
    (c) => c.name.toLowerCase() === lc || c.demonym.toLowerCase() === lc || c.code.toLowerCase() === lc
  );
  if (hit) return hit;
  // dial code: pick the LONGEST matching prefix (e.g. +1 vs +1242)
  if (v.startsWith("+")) {
    const digits = v.replace(/[^0-9+]/g, "");
    const matches = COUNTRIES.filter((c) => digits.startsWith(c.dial)).sort(
      (a, b) => b.dial.length - a.dial.length
    );
    if (matches.length) return matches[0];
  }
  // loose contains on name (last resort)
  return COUNTRIES.find((c) => c.name.toLowerCase().includes(lc)) || null;
}

// Split a stored phone string into { country, rest } so the dial code can be
// shown in the dropdown and the remaining digits in the text box.
export function splitPhone(phone) {
  if (!phone) return { country: null, rest: "" };
  const v = String(phone).trim();
  if (!v.startsWith("+")) return { country: null, rest: v };
  const matches = COUNTRIES.filter((c) => v.replace(/\s/g, "").startsWith(c.dial)).sort(
    (a, b) => b.dial.length - a.dial.length
  );
  const country = matches[0] || null;
  const rest = country ? v.replace(/\s/g, "").slice(country.dial.length) : v;
  return { country, rest };
}
